/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-09 13:09:27
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-01 16:23:41
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/SalesChannel.ts
 */
/**
 * type definition for sales channel feature.
 * Author: Chris
 * CreatedAt: 2021-03-08
 */

import { EnumModuleType } from './module';
import { Image } from './common';
import { ProductItem } from './product';
import { EnumPromotionField } from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/common';
import { ILinkModule, ILinkImage } from './linkType';
import { CustomerDatabase } from './customerDb';
import { IWarehouse } from './warehouse';
// import {
//   ICarouselModule,
//   ILongCanvas,
//   IPoster,
//   IProductCarousel,
//   IProductGrid,
//   IProductList,
//   IText,
// } from './module';

export enum SalesChannelStatus {
  draft = 'Draft',
  scheduled = 'Scheduled',
  live = 'Live',
}
export enum ChannelType {
  Website = 'Website',
  Mobile = 'Mobile',
  MiniProgram = 'MiniProgram',
  MiniProgramNativeMobile = 'MiniProgramNativeMobile',
  WholeSale = 'WholeSale',
  Facebook = 'Facebook',
  EBay = 'EBay',
}

export enum EPreviewSize {
  WIDE = 'PC',
  NARROW = 'NARROW',
  TABLET = 'TABLET',
  MOBILE = 'MOBILE',
  // '1440' = '1440',
}

export enum EContentEnd {
  pc = 'pc',

  tablet = 'tablet',
  mobile = 'mobile',
  // '1440' = '1440',
}

export enum ESocialMediaType {
  Wechat = 'Wechat',
  FaceBook = 'FaceBook',
  Instagram = 'Instagram',
  Weibo = 'Weibo',
  Twitter = 'Twitter',
  Other = 'Other',
}

export enum WebSiteSubType {
  ResponsivePage = 'Responsive',
  NativeMobile = 'Native',
}

export enum SubscriptionLayoutOption {
  ONE_COLUMN = 'ONE_COLUMN',
  TWO_COLUMN = 'TWO_COLUMN',
  LEFT_TEXT_RIGHT_FORM = 'LEFT_TEXT_RIGHT_FORM',
}

export enum SubscriptionBackgroundType {
  NONE = 'NONE',
  COLOR = 'COLOR',
}

export interface ISalesChannel {
  salesChannelUuid: string;
  channelType: ChannelType;
  name: string;
}

export interface IContentHomepageBasicElement {
  moduleName: string;
  moduleType: EnumModuleType;
  visible: boolean;
}

export interface ISalesChannelContent {
  salesChannelUuid: string;
  uuid: string;
  versionName: string;
  status: SalesChannelStatus;
}

export interface IFeatureProduct {
  isValid: boolean;
  title: string;
  dataSet: Array<unknown>;
  titleTextColor?: string;
  moduleType?: string;
}

export interface IContentSetting {
  text: string;
  image: Image;
}

export enum I404Setting {
  ContentSetting = 'Content Setting',
  ButtonText = 'Button Text',
}

export type TabBarItem = {
  draggableId: string;
  title: string;
  icon: Image;
  link: ILinkModule;
  isHome: boolean;
};

export type TabBarSetting = {
  id: string;
  originalId?: string;
  name?: string;
  display: 'fixed' | 'scroll';
  backgroundColor: string;
  inactiveColor: string;
  activeColor: string;
  tabs: Array<TabBarItem>;
  startTime: string;
  endTime: string;
  isDefault: boolean;
  showError: boolean;
};
export interface IHotTags {
  title: string;
  products: ProductItem[];
}

export interface ISearchBar {
  placeholder: string;
}

export interface IFeaturedProducts {
  titleTextColor: string;
  enabled: boolean;
  title: string;
  products: ProductItem[];
}

export interface ISalesChannelEditorBasic {
  storeUuid: string;
  errorDetail: { [propsName: string]: string };
  hasError: boolean;

  salesChannelName: string;
  createdDate: string;
  modifiedDate: string;
}
export interface ISalesChannelEditorContentBasic
  extends ISalesChannelEditorBasic {
  contentUuid?: string;
  salesChannelContent;
}

export interface ISalesChannelEditorProductBasic
  extends ISalesChannelEditorBasic {
  salesChannelProductUuid?: string;
  salesChannelProduct;
}
export enum EnumContentPageStatus {
  InUse = 'InUse',
  Pending = 'Pending',
  Previous = 'Previous',
}

export interface ISearchBar {
  placeholder: string;
}

export interface IContentSearchPage {
  uuid: string;
  searchBar: ISearchBar;
  enabled: boolean;
  hotTags: IHotTags;
  featuredProducts: IFeaturedProducts;
}

export interface IEdmField {
  draggableId?: string;
  category: EnumPromotionField | IEdmFieldCategory; //e.g. "FirstName, email, custom field"
  type: string; //e.g. "TextField, dropdown",
  name: string; //field name as placeholder, for both custom and default field
  required: boolean;
  options?: string[]; //drop down options
  fieldTitle?: string; //custom field title for internal use
  tacs?: ITac[];
}

export interface IEdm {
  homePage: { checked: boolean; title: string };
  profilePage: { checked: boolean; title: string };
  title: string;
  description: string;
  backgroundColor: string;
  textColor: string;
  buttonStyle: {
    text: string;
    backgroundColor: string;
    textColor: string;
  };
  fields: IEdmField[];
  tAcs: Record<string, unknown>[];
}

export interface IMockImage extends ILinkImage {
  enabled: boolean;
  caption: string;
}
export interface ILinkProductCustomization
  extends ISalesChannelEditorProductBasic {
  enabled: boolean;
  mockupImage: IMockImage;
  selectedServiceUuid: string;
  termsAndConditionsUuid: string;
  productServices: ProductItem[];
}

export interface IPopUpWindow {
  id?: string;
  remark?: string;
  promotionType?: string; //"ImageAndLink", "EDM",
  image?: {
    uuid: string;
    entityUuid: string;
    referenceUuid: string;
    contentType: string;
    fileName: string;
    originalName: string;
    size: number;
    url: string;
    caption: string;
    width: number;
    height: number;
    referenceType: string; //"MessageTemplate"
  };
  linkTo?: any;
  beginDate?: string;
  beginTime?: string;
  endDate?: string;
  endTime?: string;
  displayFrequency?: {
    basedOn: string; //"Period",
    frequency: number;
    periodUnit?: string; //"Day"
  };
}

export interface IPromotionProduct {
  sku: string;
  name: string;
  remarks: string;
  thumbnailUrl: string;
  productType: string; //"Simple",
  stockQuantity: number;
  stockAvailable: number;
  defaultSalePrice: number;
  defaultCurrency: string;
  quotaEnabled: true;
  inventoryQuota: number;
  dimensions: {
    weight: number;
    weightUnit: string;
    measurementUnit: string;
    length: number;
    width: number;
    volume: number;
  };
  tags: [
    {
      uuid: string;
      name: string;
    },
  ];
  status: string; //"Draft",
  brand: string;
  barcode: string;
  description: string;
  codes: [
    {
      title: string;
      code: string;
    },
  ];
  cost: 0;
  weight: 0;
  brandName: string;
  volume: 0;
}

export interface IFeaturedProduct {
  shopCart: { checked: boolean; title: string };
  profile: { checked: boolean; title: string };
  productSearch: { checked: boolean; title: string };
  fourZeroFour: { checked: boolean; title: string };
  title: string;
  products: IPromotionProduct[];
}

export interface IPromotion extends ISalesChannelEditorContentBasic {
  uuid: string;
  hasError: boolean;
  featuredProducts: IFeaturedProduct;
  edm: IEdm;
  popupWindows: {
    inUse: IPopUpWindow[];
    pending: IPopUpWindow[];
    previous: IPopUpWindow[];
    editing: IPopUpWindow;
  };
}

export interface IContentSearchPageFromServer
  extends IContentSearchPage,
    ISalesChannelEditorContentBasic {}

export interface IEmptyStateSetting {
  image: Image | null;
  text: string;
  background: string;
}
export interface IButtonStyle {
  backgroundColor: string;
  text: string;
  textColor: string;
}
export interface IContentShoppingCart {
  uuid: string;
  emptyStateSetting: IEmptyStateSetting;
  buttonStyle: IButtonStyle;
  featuredProducts: IFeaturedProducts;
}
export interface IContentShoppingCartFromServer
  extends IContentShoppingCart,
    ISalesChannelEditorContentBasic {}

export const MAX_DATE = '2021-06-01 10:00';
export interface IBackgroundStyle {
  image: Image;

  backgroundColor: string;
}

export interface IProfilePolicy {
  items: IProfilePolicyItem[];
}

export interface IProfilePolicyItem {
  title: string;

  linkTo: string;
}

export interface IContentProfilePage {
  uuid: string;

  storeUuid: string;

  contentUuid: string;

  salesChannelName: string;

  hasError: boolean;

  backgroundStyle: IBackgroundStyle;

  policy: IProfilePolicy;

  modules: Array<IFeaturedProductsDecorator | IEdmType>;
}

interface IFeaturedProductsDecorator {
  title: string;

  enabled: boolean;

  titleTextColor: string;

  products: ProductItem;
}

export interface IEdmType {
  showInHomePage: boolean;

  showInProfilePage: boolean;

  title: string;

  description: string;

  backgroundColor: string;

  textColor: string;

  buttonStyle: IButtonStyle2;

  moduleType: string;

  tacs: any;

  fields: IEdmField[];
}

interface IButtonStyle2 {
  text: string;

  backgroundColor: string;

  textColor: string;
}

export enum IEdmFieldCategory {
  FirstName = 'FirstName',

  LastName = 'LastName',

  DateOfBirth = 'DateOfBirth',

  Gender = 'Gender',

  CustomField = 'CustomField',
}

export interface ITac {
  description: string;
}

export interface ITopLeaderBoardBanner {
  enabled: boolean;
  linkModule: ILinkModule;
  uuid: string;
}

export interface IProductMenuNode {
  title: string;
  linkModule: ILinkModule;
  children: IProductMenuNode[];
}
export interface IProductMenu {
  enabled: boolean;
  roots: IProductMenuNode[];
}
export interface IAllProductPage extends ISalesChannelEditorBasic {
  uuid: string;
  topLeaderBoardBanner: ITopLeaderBoardBanner;
  productMenu: IProductMenu;
}

export interface SlugSeoSetting {
  title: string;
  description: string;
  urlSlug: string;
  slugValid: boolean;
}
export interface SalesChannelCollection {
  uuid: string;
  createdBy?: string;
  modifiedBy?: string;
  createdDate?: string;
  modifiedDate?: string;
  valid?: boolean;
  deleted?: boolean;
  storeUuid: string;
  salesChannelUuid: string;
  visible?: boolean;
  collectionName: string;
  seoSetting: SlugSeoSetting;
  imageUuid: string;
  salesChannelProductUuids: string[];
}
export enum EnumSalesChannelProductType {
  Original = 'Original',
  Alias = 'Alias',
}

export interface SalesChannel {
  uuid: string;
  name: string;
  channelType: ChannelType;
  primaryLanguage: string;
  availableLanguages: string[];
  timezone: string;
  timezoneGmt: string;
  primaryCurrency: string;
  customerDatabase: CustomerDatabase;
  warehouse: IWarehouse;
  miniProgramAppId: string;
  miniQRCodeUrl: string;
}

export enum SalesChannelMode {
  ECOMMERCE = 'ECOMMERCE',
  INFO = 'INFO',
  INFO_SISTER = 'INFO_SISTER',
}

export enum SalesChannelModeWithSister {
  E_Only = 'E_Only',
  I_Only = 'I_Only',
  I_I = 'I_I',
  I_E = 'I_E',
}
